<script lang="ts">
  import type {EnergyLabel} from "../../../../types/CinemaProductsDto.types.ts";

  interface EekSheetProps {
    activeLabel: EnergyLabel | null;
  }

  let {activeLabel = $bindable(null)}: EekSheetProps = $props();

  function afterSheetClose() {
    activeLabel = null;
  }
</script>

{#if activeLabel}
  <oc-sheet-v1
      onoc-sheet-after-close={afterSheetClose}
      open
  >
    <h3 slot="headline">{activeLabel.title}</h3>
    <div class="energy-sheet">
      {#if activeLabel.labelUri}
      <img alt={activeLabel.title} src={activeLabel.labelUri} loading="lazy"/>
      {/if}
      {#if activeLabel.datasheetUri}
        <oc-button-v1
            size={"100"}
            variant="secondary"
            base64-href={btoa(activeLabel.datasheetUri)}
            target="_blank"
            class="oc-copy-125"
            oc-aria-label={`Produktdatenblatt (PDF) ${activeLabel.descriptor}`}
        >
          Produktdatenblatt (PDF)
        </oc-button-v1>
      {/if}
    </div>
  </oc-sheet-v1>
{/if}

<style lang="scss">
  .energy-sheet {
    img {
      max-width: 100%;
    }
  }
</style>
